// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2RPMM","header":"PatientQuestionnaire_header__3D2T-","info":"PatientQuestionnaire_info__11-Uk"};